import Vue from 'vue'

const url = 'targettimes'
const targettimes = {
  namespaced: true,
  state: {
    targettimes: []
  },
  // CRUD / RESTful actions
  mutations: {
    SET(state, data) {
      state.targettimes = data
    },
    NEW(state, data) {
      state.targettimes.unshift(data)
    },
    UPD(state, data) {
      const index = state.targettimes.findIndex(t => t.id == data)
      if(index !== -1) {
        state.targettimes.splice(index, 1, data)
      }
    },
    DEL(state, data) {
      state.targettimes = state.targettimes.filter(targettimes => targettimes.id != data.id)
    }
  },
  actions: {
    async fetch({commit}) {
      const response = await Vue.prototype.$axios.get(url)
      commit('SET', response.data)
    },
    async create({commit}, targettime) {
      Vue.prototype.$axios.post(url, targettime).then(res => {
        Vue.prototype.$toastr.s('Created new Target Time.')
        commit('NEW', res.data)
      }).catch(err => {
        console.log(err)
        Vue.prototype.$toastr.e('Could note create Target Time.')
      })
    },
    async update({commit}, targettime) {
      Vue.prototype.$axios.put(url + '/' + targettime.id, targettime).then(res => {
        Vue.prototype.$toastr.s('Updated ' + targettime.name)
        commit('UPD', res.data)
      }).catch(err => {
        Vue.prototype.$toastr.e('Error.', err.data)
        console.log(err)
      })
    },
    async remove({commit}, targettime) {
      const response = await Vue.prototype.$axios.delete(url + '/' + targettime.id)
      Vue.prototype.$toastr.s('Deleted Target Time Successfully')
      commit('DEL', response.data)
    }
  },
  getters: {
    all: state => state.targettimes,
    byClient:(state) => (id) => {
      return state.targettimes.filter(targettime => {
        return targettime.client_id == id
      })
    }
  }
}

export default targettimes